import { css } from '@emotion/react';
import { flex, margins, paddings, themed } from '@spotnana/blocks/src/utils/styling';

export const fare_rules_change_container = css`
  ${flex.init}
  ${flex.column}
  gap: 24px;
  ${margins.yb.m1point5}
`;
export const fare_rules_change_subtext = css`
  line-height: 20px;
`;
export const fare_rules_change_fare_blocks = css`
  display: flex;
  gap: 16px;
`;
export const fare_rules_change_fare_block = themed(
  ({ palette }) => css`
    ${paddings.x.p1}
    ${paddings.y.p1}
    border:solid 1px ${palette.border.light};
    border-radius: 8px;
    flex-grow: 1;
  `,
);
export const fare_rules_change_fare_block_new_fare = themed(
  ({ palette }) => css`
    border: solid 1px ${palette.border.hover};
  `,
);
export const fare_rules_change_fare_block_title = css`
  ${flex.init}
  ${flex.align.baseline}
  gap: 8px;
  margin-bottom: 4px;
`;
export const fare_rules_change_fare_block_airport = css`
  ${flex.init}
  ${flex.align.center}
  gap: 4px;
`;
